// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PJnQ_","icon":"styles_icon__CeFLZ"};